import React, { useState, useEffect } from 'react'
import { Modal, SelectionBox } from '@enamelai/design-system'
import { CommunicationFlowType } from '@dataTypes/clinic.type'
import './SelectFlowTypeModalStyle.css'

type SelectFlowTypeModalProps = {
  open: boolean
  onClose: () => void
  onSelect: (flowType: CommunicationFlowType) => void
}

const OPTIONS: {
  type: CommunicationFlowType
  title: string
  description: string
}[] = [
  {
    type: 'call',
    title: 'Call flow',
    description:
      'Manage call routes, processes, and handle phone calls hands-free.',
  },
  {
    type: 'sms',
    title: 'SMS flow',
    description: 'Send hands-free, timed text messages.',
  },
]

const SelectFlowTypeModal = ({
  open,
  onClose,
  onSelect,
}: SelectFlowTypeModalProps): React.ReactElement => {
  const [selectedOption, setSelectedOption] =
    useState<CommunicationFlowType | null>(null)

  useEffect(() => {
    if (open) {
      setSelectedOption(null)
    }
  }, [open])

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeOnBackdrop={false}
      size="md"
      title="Select flow"
      primaryLabel="Confirm"
      onPrimaryClick={() => {
        if (!selectedOption) return
        onSelect(selectedOption)
      }}
      primaryDisabled={!selectedOption}
      secondaryLabel="Cancel"
      onSecondaryClick={onClose}
      className="scp-select-flow-type-modal"
    >
      <div className="scp-select-flow-type">
        {OPTIONS.map((option) => (
          <SelectionBox
            key={option.type}
            title={option.title}
            description={option.description}
            value={option.type}
            selected={selectedOption === option.type}
            onSelect={() => setSelectedOption(option.type)}
          />
        ))}
      </div>
    </Modal>
  )
}

export default SelectFlowTypeModal
